import axios from 'axios';
import * as qs from 'qs';
import { ICrudDeleteAction, ICrudGetAction, ICrudPutAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';

import { defaultValue, ISignAttachmentSetting } from 'app/shared/model/sign-attachment-setting.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { flattenKey } from 'app/shared/util/object-utils';

export const ACTION_TYPES = {
  FETCH_SIGNATTACHMENTSETTING_LIST: 'signAttachmentSetting/FETCH_SIGNATTACHMENTSETTING_LIST',
  LOAD_SIGNATTACHMENTSETTING_LIST: 'signAttachmentSetting/LOAD_SIGNATTACHMENTSETTING_LIST',
  FETCH_SIGNATTACHMENTSETTING: 'signAttachmentSetting/FETCH_SIGNATTACHMENTSETTING',
  CREATE_SIGNATTACHMENTSETTING: 'signAttachmentSetting/CREATE_SIGNATTACHMENTSETTING',
  UPDATE_SIGNATTACHMENTSETTING: 'signAttachmentSetting/UPDATE_SIGNATTACHMENTSETTING',
  DELETE_SIGNATTACHMENTSETTING: 'signAttachmentSetting/DELETE_SIGNATTACHMENTSETTING',
  SET_BLOB: 'signAttachmentSetting/SET_BLOB',
  RESET: 'signAttachmentSetting/RESET'
};

const initialState = {
  loading: false,
  loadMore: false,
  fetching: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ISignAttachmentSetting>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0
};

export type SignAttachmentSettingState = Readonly<typeof initialState>;

export default (state: SignAttachmentSettingState = initialState, action): SignAttachmentSettingState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case REQUEST(ACTION_TYPES.LOAD_SIGNATTACHMENTSETTING_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loadMore: true
      };
    case REQUEST(ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_SIGNATTACHMENTSETTING):
    case REQUEST(ACTION_TYPES.DELETE_SIGNATTACHMENTSETTING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case REQUEST(ACTION_TYPES.UPDATE_SIGNATTACHMENTSETTING):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
        entity: action.meta.entity
      };
    case FAILURE(ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING):
    case FAILURE(ACTION_TYPES.CREATE_SIGNATTACHMENTSETTING):
    case FAILURE(ACTION_TYPES.UPDATE_SIGNATTACHMENTSETTING):
    case FAILURE(ACTION_TYPES.DELETE_SIGNATTACHMENTSETTING):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.LOAD_SIGNATTACHMENTSETTING_LIST):
      return {
        ...state,
        loadMore: false,
        entities: state.entities.concat(action.payload.data),
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_SIGNATTACHMENTSETTING):
    case SUCCESS(ACTION_TYPES.UPDATE_SIGNATTACHMENTSETTING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_SIGNATTACHMENTSETTING):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.SET_BLOB:
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType
        }
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/sign-attachment-settings';

// Actions

export const getEntities: ICrudGetListAction<ISignAttachmentSetting> = (page, size, sort = 'createdAt,desc', searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING_LIST,
    payload: axios.get(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    }),
    meta: { transformUserName: true }
  };
};

export const loadEntities: ICrudGetListAction<ISignAttachmentSetting> = (page, size, sort = 'createdAt,desc', searchForm) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.LOAD_SIGNATTACHMENTSETTING_LIST,
    payload: axios.get(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'indices' })
    }),
    meta: { transformUserName: true }
  };
};

export const getEntity: ICrudGetAction<ISignAttachmentSetting> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_SIGNATTACHMENTSETTING,
    payload: axios.get<ISignAttachmentSetting>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<ISignAttachmentSetting> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_SIGNATTACHMENTSETTING,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<ISignAttachmentSetting> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_SIGNATTACHMENTSETTING,
    payload: axios.put(apiUrl, cleanEntity(entity)),
    meta: { entity: cleanEntity(entity) }
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<ISignAttachmentSetting> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_SIGNATTACHMENTSETTING,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType
  }
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
